import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material/styles";

export const StyledButtonWrapper = styled("div")(() => (
  { margin: "2rem 0", display: "flex", justifyContent: "space-between" }
));

export const StyledRowActionButton = styled(LoadingButton)(() => ({ minWidth: "5rem" }));
